// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import './index.scss';
// import axiosInstance from "../services/api/API";
// import { Modal } from "react-bootstrap";
// import notificationIcon from "../../Assets/icons/notificationIcon.svg"

// import closeNotification from "../../Assets/icons/notificationClose.svg"

// const DealerManagement = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { cardsData } = location.state || {};
//   const [dealers, setDealers] = useState([]);

//   const isLoggedIn = localStorage.getItem("isLoggedIn");

//   console.log(isLoggedIn, "cardData")

//   const token = localStorage.getItem("authToken");

//   const [VeriantListShow, setVeriantListShow] = useState(false);

//   const [ titleVal, setTitleVal ] = useState("")

//   const [ imageVal, setImageVal ] = useState("")

//   const [ descriptionVal , setDescriptionVal ] = useState("")

//   const [zoomedImageShow, setZoomedImageShow] = useState(false);

// const [notifications, setNotifications] = useState([]); // Store all notifications
// const [currentNotificationIndex, setCurrentNotificationIndex] = useState(0); // Track current notification index

// useEffect(() => {
//   notificationView()
// },[])

// const notificationView = async () => {
//   try {
//     const response = await axiosInstance.get("/notification/notification-view", {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     const fetchedData = response?.data?.data;
//     console.log(fetchedData, "fetchedData");

//     if (fetchedData?.length > 0) {
//       setNotifications(fetchedData); // Set all notifications
//       setCurrentNotificationIndex(0); // Start with the first notification
//       setVeriantListShow(true); // Show modal
//     }
//   } catch (error) {
//     console.log(error, "error");
//   }
// };

// const handleNextNotification = () => {
//   if (currentNotificationIndex < notifications.length - 1) {
//     setCurrentNotificationIndex((prevIndex) => prevIndex + 1); // Move to the next notification
//   } else {
//     setVeriantListShow(false); // Close modal if all notifications are viewed
//   }
// };

//   useEffect(() => {
//     const fetchCardData = async () => {
//       try {
//         const token = localStorage.getItem("authToken");
//         const response = await axiosInstance.get("/get-card", {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         console.log("Fetch card data:", response.data);
//         const fetchedDealers = response.data.data?.data || [];
//         setDealers(response.data.data?.data);

//         // If there is only one dealer, navigate directly
//         if (fetchedDealers.length === 1) {
//           const singleDealer = fetchedDealers[0];
//           localStorage.setItem("selectedCardId", singleDealer.id);
//           navigate(`/cards/${singleDealer.card_url}`, {
//             state: { card_id: singleDealer.id },
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching card data:", error);
//       }
//     };

//     fetchCardData();
//   }, [navigate]);

//   const extractFileName = (path) => {
//     const parts = path.split('/');
//     return parts[parts.length - 1];
//   };

//   const handleCardClick = (dealer) => {
//     localStorage.setItem('selectedCardId', dealer.id);
//     navigate(`/cards/${dealer.card_url}`, { state: { card_id: dealer.id } });
//   };

//   return (

// <div className="mainContainer d-flex align-items-center justify-content-center">
//   <div className="row" style={{ margin: 0 }}>
//     <div className="text-center mb-4" style={{ color: "#fff" }}>
//       <h1>Dealer Management System (DMS)</h1>
//       <p>
//         Dealer management systems (DMS) streamline dealership operations,
//         providing real-time insights into sales, service, and inventory.
//       </p>
//     </div>
//   </div>

//   <div className="row card-container" style={{ margin: 0 }}>
//     {dealers.map((dealer, index) => (
//       <div
//         key={index}
//         className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-4"
//         onClick={() => handleCardClick(dealer)}
//         style={{ cursor: "pointer" }}
//       >
//         <div className="card text-center">
//           <div className="card-body">
//             <div className="icon mb-3">
//               <img src={dealer?.card_icon} alt={dealer.card_name} />
//             </div>
//             <h5 className="card-title">{dealer.card_name}</h5>
//           </div>
//         </div>
//       </div>
//     ))}
//   </div>

// {VeriantListShow && notifications.length > 0 && (
//     <Modal
//       show={VeriantListShow}
//       centered
//       style={{ paddingLeft: "400px !important" }}
//       size="xl"
//     >
//       <Modal.Header>
//         <Modal.Title style={{ position: "relative" }}>
//           <img src={notificationIcon} alt="notificationIcon" />
//           <img
//             onClick={handleNextNotification} // Close current notification
//             className="notificationClose"
//             src={closeNotification}
//             alt="closeNotification"
//           />
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <img
//             src={notifications[currentNotificationIndex]?.imagepath}
//             alt="NotImage"
//             style={{ height: "100px", width: "150px", cursor: "pointer" }}
//             onClick={() => setZoomedImageShow(true)}
//           />
//           <h3
//             style={{
//               textAlign: "center",
//               fontWeight: "600",
//               fontSize: "40px",
//             }}
//           >
//             {notifications[currentNotificationIndex]?.title}
//           </h3>
//           <p
//             style={{
//               textAlign: "center",
//               fontWeight: "400",
//               fontSize: "22px",
//             }}
//             dangerouslySetInnerHTML={{
//               __html: notifications[currentNotificationIndex]?.notiDescription,
//             }}
//           />
//         </div>
//       </Modal.Body>
//     </Modal>
//   )}

// {zoomedImageShow && (
//   <>
//     {/* Full-Screen Blur Overlay */}
//     <div className="blur-overlay"></div>
//     <Modal
//       show={zoomedImageShow}
//       centered
//       onHide={() => setZoomedImageShow(false)}
//       dialogClassName="zoom-modal"
//     >
//       <Modal.Body style={{ position: "relative", padding: 0 }}>
//         {/* Close Button */}
//         <span
//           style={{
//             position: "absolute",
//             top: "-121px",
//             right: "-35%",
//             fontSize: "30px",
//             fontWeight: "bold",
//             cursor: "pointer",
//             color: "white",
//             zIndex: 1000,
//           }}
//           onClick={() => setZoomedImageShow(false)}
//         >
//           &times;
//         </span>
//         {/* Enlarged Image */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             height: "10vh",
//             width: "10vw",
//             backdropFilter: "blur(8px)",
//             backgroundColor: "rgba(0, 0, 0, 0.8)",
//           }}
//         >
//           <img
//             src={imageVal}
//             alt="ZoomedImage"
//             style={{
//               maxHeight: "55vh",
//               maxWidth: "55vw",
//               objectFit: "contain",
//               border: "5px solid white",
//               boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
//             }}
//           />
//         </div>
//       </Modal.Body>
//     </Modal>
//   </>
// )}
// </div>

//   );
// };

// export default DealerManagement;

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import axiosInstance from "../services/api/API";
import { Modal } from "react-bootstrap";
import notificationIcon from "../../Assets/icons/notificationIcon.svg";
import { FaDownload } from "react-icons/fa";
import closeNotification from "../../Assets/icons/notificationClose.svg";

const DealerManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cardsData } = location.state || {};
  const [dealers, setDealers] = useState([]);

  const isLoggedIn = localStorage.getItem("isLoggedIn");

  console.log(isLoggedIn, "cardData");

  const token = localStorage.getItem("authToken");
  const UserId = localStorage.getItem("UserId");

  const [VeriantListShow, setVeriantListShow] = useState(false);

  const [titleVal, setTitleVal] = useState("");

  const [imageVal, setImageVal] = useState("");

  const [descriptionVal, setDescriptionVal] = useState("");

  const [zoomedImageShow, setZoomedImageShow] = useState(false);

  const [notifications, setNotifications] = useState([]); // Store all notifications
  const [currentNotificationIndex, setCurrentNotificationIndex] = useState(0); // Track current notification index

  useEffect(() => {
    notificationView();
  }, []);

  const isImage = (url) => {
    if (!url) return false;
    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".bmp",
      ".webp",
      ".svg",
    ];
    return imageExtensions.some((ext) => url.toLowerCase().endsWith(ext));
  };

  const notificationView = async () => {
    try {
      const response = await axiosInstance.get(
        "/notification/notification-view",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedData = response?.data?.data;
      console.log(fetchedData, "fetchedData");

      const seenKey = `notifications_shown_${UserId}`;
      const alreadyShown = UserId && localStorage.getItem(seenKey) === "true";

      // if (fetchedData?.length > 0) {
      //   setNotifications(fetchedData); // Set all notifications
      //   setCurrentNotificationIndex(0); // Start with the first notification
      //   setVeriantListShow(true); // Show modal
      // }

      if (fetchedData?.length > 0 && !alreadyShown) {
        setNotifications(fetchedData); // Set all notifications
        setCurrentNotificationIndex(0); // Start with the first notification
        setVeriantListShow(true); // Show modal
        if (UserId) localStorage.setItem(seenKey, "true"); // mark as shown for this user
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleNextNotification = () => {
    if (currentNotificationIndex < notifications.length - 1) {
      setCurrentNotificationIndex((prevIndex) => prevIndex + 1); // Move to the next notification
    } else {
      setVeriantListShow(false); // Close modal if all notifications are viewed
    }
  };

  useEffect(() => {
    const fetchCardData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axiosInstance.post(
          "/get-card",
          {
            UserId: UserId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Fetch card data:", response.data);
        const fetchedDealers = response.data.data?.data || [];
        setDealers(response.data.data?.data);

        // If there is only one dealer, navigate directly
        if (fetchedDealers.length === 1) {
          const singleDealer = fetchedDealers[0];
          localStorage.setItem("selectedCardId", singleDealer.id);
          navigate(`/cards/${singleDealer.card_url}`, {
            state: { card_id: singleDealer.id },
          });
        }
      } catch (error) {
        console.error("Error fetching card data:", error);
      }
    };

    fetchCardData();
  }, [navigate]);

  const extractFileName = (path) => {
    const parts = path.split("/");
    return parts[parts.length - 1];
  };

  const handleCardClick = (dealer) => {
    localStorage.setItem("selectedCardId", dealer.id);
    navigate(`/cards/${dealer.card_url}`, { state: { card_id: dealer.id } });
  };

  const downloadImage = (imageUrl) => {
    if (!imageUrl) return;

    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "downloaded_image.jpg"; // You can change the filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Error downloading image:", error));
  };

  return (
    <div className="mainContainerr d-flex ">
      <div className="row" style={{ margin: 0 }}>
        <div className="text-center mb-4" style={{ color: "#fff" }}>
          <h1>Dealer Management System (DMS)</h1>
          <p>
            Dealer management systems (DMS) streamline dealership operations,
            providing real-time insights into sales, service, and inventory.
          </p>
        </div>
      </div>

      <div className="row card-container" style={{ margin: 0 }}>
        {dealers.map((dealer, index) => (
          <div
            key={index}
            className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-4"
            onClick={() => handleCardClick(dealer)}
            style={{ cursor: "pointer" }}
          >
            <div className="card text-center">
              <div className="card-body">
                <div className="icon mb-3">
                  <img src={dealer?.card_icon} alt={dealer.card_name} />
                </div>
                <h5 className="card-title">{dealer.card_name}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>

      {VeriantListShow && notifications.length > 0 && (
        <Modal show={VeriantListShow} centered size="xl" backdrop="static">
          <Modal.Body
            style={{
              padding: "40px",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              position: "relative",
              maxWidth: "700px",
              margin: "auto",
            }}
          >
            <span
              onClick={handleNextNotification}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
                fontSize: "24px",
                fontWeight: "bold",
                color: "#333",
              }}
            >
              ×
            </span>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              {/* <div style={{ position: "relative", marginBottom: "20px" }}>
                <img
                  src={notifications[currentNotificationIndex]?.imagepath}
                  alt="NotImage"
                  style={{
                    height: "200px",
                    width: "250px",
                    cursor: "pointer",
                    borderRadius: "8px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                  onClick={() => {
                    setImageVal(
                      notifications[currentNotificationIndex]?.imagepath
                    );
                    setZoomedImageShow(true);
                  }}
                />
                <FaDownload
                  onClick={() =>
                    downloadImage(
                      notifications[currentNotificationIndex]?.imagepath
                    )
                  }
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    cursor: "pointer",
                    color: "white",
                    background: "#7BD755",
                    borderRadius: "50%",
                    padding: "5px",
                    fontSize: "16px",
                  }}
                />
              </div> */}
              {(() => {
                const currentNotif = notifications[currentNotificationIndex];
                const filePath = currentNotif?.imagepath;
                const isImageFile = isImage(filePath);
                const isPdfFile =
                  filePath && filePath.toLowerCase().endsWith(".pdf");

                return (
                  <div style={{ position: "relative", marginBottom: "20px" }}>
                    {isImageFile ? (
                      <>
                        <img
                          src={filePath}
                          alt="NotImage"
                          style={{
                            height: "200px",
                            width: "250px",
                            cursor: "pointer",
                            borderRadius: "8px",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          }}
                          onClick={() => {
                            setImageVal(filePath);
                            setZoomedImageShow(true);
                          }}
                        />
                        <FaDownload
                          onClick={() => downloadImage(filePath)}
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            cursor: "pointer",
                            color: "white",
                            background: "#7BD755",
                            borderRadius: "50%",
                            padding: "5px",
                            fontSize: "16px",
                          }}
                        />
                      </>
                    ) : isPdfFile ? (
                      <>
                        <iframe
                          src={filePath}
                          style={{
                            height: "400px",
                            width: "100%",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          }}
                          title="PDF Viewer"
                        />
                        <FaDownload
                          onClick={() => downloadImage(filePath)}
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            cursor: "pointer",
                            color: "white",
                            background: "#7BD755",
                            borderRadius: "50%",
                            padding: "5px",
                            fontSize: "16px",
                          }}
                        />
                      </>
                    ) : (
                      <p>No supported file to display.</p>
                    )}
                  </div>
                );
              })()}
              <h3
                style={{
                  fontWeight: "600",
                  fontSize: "32px",
                  marginBottom: "15px",
                  color: "#333",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {notifications[currentNotificationIndex]?.title || "No Title"}
              </h3>
              <div
                style={{
                  fontWeight: "400",
                  fontSize: "18px",
                  lineHeight: "1.5",
                  color: "#555",
                  maxWidth: "600px",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    notifications[currentNotificationIndex]?.notiDescription ||
                    "No Description",
                }}
              />
            </div>
          </Modal.Body>
        </Modal>
      )}

      {zoomedImageShow && (
        <>
          <div className="blur-overlay"></div>
          <Modal
            show={zoomedImageShow}
            centered
            onHide={() => setZoomedImageShow(false)}
            dialogClassName="zoom-modal"
            size="lg"
          >
            <Modal.Body
              style={{
                position: "relative",
                padding: 0,
                backgroundColor: "rgba(0, 0, 0, 0.9)",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "15px",
                  fontSize: "30px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  color: "white",
                  zIndex: 1000,
                }}
                onClick={() => setZoomedImageShow(false)}
              >
                &times;
              </span>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "70vh",
                  minWidth: "70vw",
                }}
              >
                <img
                  src={imageVal}
                  alt="ZoomedImage"
                  style={{
                    maxHeight: "65vh",
                    maxWidth: "65vw",
                    objectFit: "contain",
                    border: "5px solid white",
                    boxShadow: "0 0 20px rgba(0, 0, 0, 0.7)",
                  }}
                />
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}

      {/* {VeriantListShow && notifications.length > 0 && (
        <Modal
          show={VeriantListShow}
          centered
          style={{ paddingLeft: "400px !important" }}
          size="xl"
        >
          <Modal.Header>
            <Modal.Title style={{ position: "relative" }}>
              <img src={notificationIcon} alt="notificationIcon" />
              <img
                onClick={handleNextNotification} // Close current notification
                className="notificationClose"
                src={closeNotification}
                alt="closeNotification"
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={notifications[currentNotificationIndex]?.imagepath}
                alt="NotImage"
                style={{ height: "100px", width: "150px", cursor: "pointer" }}
                onClick={() => setZoomedImageShow(true)}
              />
              <FaDownload
                onClick={() =>
                  downloadImage(
                    notifications[currentNotificationIndex]?.imagepath
                  )
                }
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  cursor: "pointer",
                  color: "white",
                  background: "#7BD755",
                  borderRadius: "50%",
                  padding: "5px",
                  fontSize: "27px",
                }}
              />
              <h3
                style={{
                  textAlign: "center",
                  fontWeight: "600",
                  fontSize: "40px",
                }}
              >
                {notifications[currentNotificationIndex]?.title}
              </h3>
              <p
                style={{
                  textAlign: "center",
                  fontWeight: "400",
                  fontSize: "22px",
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    notifications[currentNotificationIndex]?.notiDescription,
                }}
              />
            </div>
          </Modal.Body>
        </Modal>
      )} */}

      {/* {zoomedImageShow && (
        <>
       
          <div className="blur-overlay"></div>
          <Modal
            show={zoomedImageShow}
            centered
            onHide={() => setZoomedImageShow(false)}
            dialogClassName="zoom-modal"
          >
            <Modal.Body style={{ position: "relative", padding: 0 }}>
              
              <span
                style={{
                  position: "absolute",
                  top: "-121px",
                  right: "-35%",
                  fontSize: "30px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  color: "white",
                  zIndex: 1000,
                }}
                onClick={() => setZoomedImageShow(false)}
              >
                &times;
              </span>
              
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "10vh",
                  width: "10vw",
                  backdropFilter: "blur(8px)",
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                }}
              >
                <img
                  src={imageVal}
                  alt="ZoomedImage"
                  style={{
                    maxHeight: "55vh",
                    maxWidth: "55vw",
                    objectFit: "contain",
                    border: "5px solid white",
                    boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
                  }}
                />
              </div>
            </Modal.Body>
          </Modal>
        </>
      )} */}
    </div>
  );
};

export default DealerManagement;
